export default "__VITE_ASSET__ce3b3d24__"